import React, { useEffect } from 'react';
import { viewContext } from "../../App";
import {Route, Routes} from 'react-router-dom';
import CountryCompatibility from '../countrycompatibility/CountryCompatibility';
import DealWithPeople from '../dealpeople/DealWithPeople';
import NameCompatibility from '../namecompatibility/NameCompatibility';
import PartnerCompatibility from '../partnership/PartnerCompatibility';
import LuckyNumbers from '../personalCompatibility/LuckyNumbers';
import Professions from '../professions/Professions';
import YearTrends from '../yeartrends/YearTrends';
import Login from './Login';

import Dashboard from '../home/Dashboard';

function ProtectedRoutes(props){
    
    const {state} = React.useContext(viewContext);
                    
    return(
        <>
            {state.login?
			<Routes>
				<Route path='professions' element={<Professions/>}/>
				<Route path='luckynumbers' element={<LuckyNumbers/>}/>
				<Route path='namecalculator' element={<NameCompatibility/>}/>
				<Route path='partnercompatibility' element={<PartnerCompatibility/>}/>
				<Route path='foreignsettlement' element={<CountryCompatibility/>}/>
				<Route path='yeartrends' element={<YearTrends/>}/>
				<Route path='deal_with_people' element={<DealWithPeople/>}/>
				<Route path='dashboard' element={<Dashboard/>}/>
			</Routes>
                :
                <Login/>
            }
        </>
    )
};

export default ProtectedRoutes;